import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getInventoryUploads,
  getLastProcessedInventoryUpload,
  getPastInventoryUploads,
  uploadInitialInventory,
  getFileById,
  retryBulkInventoryUpload,
} from "../services/AllServices";
import { showMessage, blobUrlToDataUrl,downloadCSV } from "../utils/helpers";

const useBulkUploadViewController = () => {
  const [loading, setLoading] = useState(true);
  const [saveStatus, setSaveStatus] = useState(true);
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [pastUploads, setPastUploads] = useState(null);
  const [lastProcessedUpload, setLastProcessedUpload] = useState(null);
  const [lastUploadStatus, setLastUploadStatus] = useState(null);

  const downloadSampleCSV = () => {
    downloadCSV(
      process.env.PUBLIC_URL + "/BulkUploadSample.csv",
      "BulkUpload Sample.csv"
    );
  };

  const fetchLastProcessedUploads = async () => {
    try {
      const responseData = await getLastProcessedInventoryUpload();
      setLastProcessedUpload(responseData.data);
      setLastUploadStatus(responseData.data.status);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPastUploads = async () => {
    try {
      const responseData = await getPastInventoryUploads();
      setPastUploads(responseData.data.initial_inventory_uploads);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const downloadFile = async (fileId) => {
    if (!fileId) return;
    const responseData = await getFileById(fileId);
    blobUrlToDataUrl(responseData);
  };

  const handleRetry = async (id) => {
    setLoading(true);
    try {
      const responseData = await retryBulkInventoryUpload(id);
      if (responseData) {
        fetchLastProcessedUploads();
        fetchPastUploads();
      } else {
        showMessage("error", responseData?.message || "Something went wrong");
      }
    } catch (error) {
      showMessage(
        "error",
        error?.response?.message || "Something went wrong"
      );
    }
    setLoading(false);
  };

  const uploadInitialInventoryFile = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("initial_inventory_upload_csv", selectedFile);
      let responseData = await uploadInitialInventory(formData);
      setLoading(false);
      if (responseData) {
        showMessage("success", "File uploaded successfully");
        fetchLastProcessedUploads();
        fetchPastUploads();
        setSaveStatus(true);
      } else {
        showMessage("error", responseData?.message || "Something went wrong");
      }
    } catch (error) {
      showMessage(
        "error",
        error?.data?.message || "Something went wrong"
      );
    }
    setSelectedFile(null);
    setFileName("");
    setLoading(false);
  };

  useEffect(() => {
    fetchLastProcessedUploads();
    fetchPastUploads();
  }, []);

  useEffect(() => {
    if (selectedFile) {
      setSaveStatus(false);
    } else {
      setSaveStatus(true);
    }
  }, [selectedFile]);

  return {
    loading,
    saveStatus,
    selectedFile,
    setSelectedFile,
    fileName,
    setFileName,
    lastProcessedUpload,
    lastUploadStatus,
    pastUploads,
    uploadInitialInventoryFile,
    handleRetry,
    downloadFile,
    downloadSampleCSV,
  };
};

export default useBulkUploadViewController;
